export default "__VITE_ASSET__$djVTL2d__"